export const columnsCsv = [
  { label: "Full Name", key: "fullName" },
  { key: "phoneNumber", label: "Mobile Number" },
  { label: "Branch Id ", key: "branchId" },
  { key: "companyName", label: "Corporate Name" },
  { key: "emiratesId", label: "Emirates Id" },
  { key: "cardSerialNo", label: "Card Serial Number" },
  { key: "registrationDate", label: "Registration Date" },
  {
    key: "userStatus",
    label: "Account Status",
  },
];

export const options = [
  { value: "Active", label: "Active" },
  { value: "Verified", label: "Verified" },
  { value: "Blocked", label: "Blocked" },
];

export const channelOptions = [
  { value: "Direct and Bank Referral", label: "Direct and Bank Referral" },
  { value: "Exchange Houses", label: "Exchange Houses" },
];
